module.exports = __webpack_public_path__ + "assets/img/text-image-landscape.369d0e30.jpg";